import React from "react";
import { Comparator, comparatorDefs, SerializedCondition } from "../types";
import Select from "@/components/Select";

export type DateCondition = {
  date: string;
  comparator: Comparator;
  recurring?: boolean;
};

export function DateEditor({
  condition,
  onUpdate
}: {
  condition: SerializedCondition;
  onUpdate: (condition: SerializedCondition) => void;
}) {
  const dateCondtion = JSON.parse(condition.data || "{}") as DateCondition;

  function update(data: DateCondition) {
    onUpdate({ ...condition, data: JSON.stringify(data) });
  }

  const validComparatorOptions: Record<string, string> = dateCondtion.recurring
    ? {
        equals: comparatorDefs.equals,
        notEquals: comparatorDefs.notEquals
      }
    : {
        equals: comparatorDefs.equals,
        greaterThan: comparatorDefs.greaterThan,
        lessThan: comparatorDefs.lessThan
      };

  // Generate unique ID for checkbox
  const checkboxId = `recurring-date-${Math.random()}`;

  return (
    <>
      <div className="flex items-center gap-2 mb-2">
        <input
          type="checkbox"
          id={checkboxId}
          className="cursor-pointer"
          checked={dateCondtion.recurring || false}
          onChange={(e) => {
            update({
              ...dateCondtion,
              recurring: e.target.checked,
              date: "", // Clear date when toggling to avoid format mismatch
              comparator: "equals" // Reset to equals for recurring dates
            });
          }}
        />
        <label htmlFor={checkboxId} className="cursor-pointer text-sm">
          Recurring yearly (e.g., Christmas every year)
        </label>
      </div>
      <Select
        options={validComparatorOptions}
        value={dateCondtion.comparator}
        onChange={(v) => update({ ...dateCondtion, comparator: v })}
      />
      {dateCondtion.recurring ? (
        <input
          type="text"
          placeholder="MM/DD (e.g., 12/25)"
          value={dateCondtion.date || ""}
          onChange={(e) => {
            update({ ...dateCondtion, date: e.target.value });
          }}
          className="border rounded-md p-2 w-full"
        />
      ) : (
        <input
          type="date"
          value={dateCondtion.date || ""}
          onChange={(e) => {
            update({ ...dateCondtion, date: e.target.value });
          }}
          className="border rounded-md p-2 w-full"
        />
      )}
    </>
  );
}
